const initScroll = (container) => {
    container.jScrollPane({
        contentWidth: '0px',
        showArrows: false,
        horizontalDragMinWidth: 2,
        horizontalDragMaxWidth: 2,
    });
};
export const reinitResizeScroll = (block) => {
    $('.js-popup-filter-list').each(function(i, item) {
        const api = $(item).jScrollPane().data('jsp');
        if ($(item).hasClass('jspScrollable')) {
            api.reinitialise();
        }
    });
};

$(window).resize(function() {
    reinitResizeScroll($('.js-popup-filter-list'))
});